export const getRestUri = state => state && state.getIn(['global', 'restUri'])
export const getAjaxLoading = state => state && state.getIn(['global', 'ajaxLoaders'])
